import { LIVECHAT_LICENSE } from 'config'
import { useUser } from 'hooks'
import { LiveChatWidget } from '@livechat/widget-react'

const LiveChat = () => {
  const { name, email } = useUser()

  if (!(LIVECHAT_LICENSE && name && email)) return null

  return <LiveChatWidget customerEmail={email} customerName={name} license={LIVECHAT_LICENSE} />
}

export default LiveChat
